import axiosClient from "@/api/common/axiosClient.ts";
import { Client } from "@/types/client.ts";

export const getClients = () => {
  return axiosClient.get<Client[]>("users/clients/");
};
